import { OutstandingBalanceApi } from '@project/services';
import { OutstandingBalanceModelType } from './types';

export const OutstandingBalanceModel = (
  data?: OutstandingBalanceApi,
): OutstandingBalanceModelType => ({
  outstandingBalance: data?.outstanding_balance ?? 0,
});
